module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0027.png.7ee10ce9.jpg";